import { Attachment } from 'src/app/shared/model/attachment';

export class PostAttachment {
  static readonly type = '[Attachment] Post New';
  constructor(
    public body: Attachment,
  ) {}
}

export class GetAttachments {
  static readonly type = '[Attachment] Get All';
  constructor(
    public emailId: string
  ) {}
}

export class UploadToS3 {
  static readonly type = '[Attachment] Upload to S3';
  constructor(public file: File[], public emailId: string) {}
}

export class DeleteAttachments {
  static readonly type = '[Attachment] Delete';
  constructor(
    public attachments: Array<Attachment>
  ) {}
}

export class UpdateAttachments {
  static readonly type = '[Attachment] Update';
  constructor(
    public attachments: Array<Attachment>
  ) {}
}

export class DownloadFromS3 {
  static readonly type = '[Attachment] Download from S3';
  constructor(
    public attachment: Attachment
  ) {}
}
